import type { TokenWithUnit } from '@pba/react-theme';

declare module '@pba/react-theme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- Bug in linter
  interface CustomThemeConfig extends ReactComponentsCustomThemeConfig {}
}

export interface ReactComponentsCustomThemeConfig {
  reactComponents: {
    attachment: {
      file: {
        width: TokenWithUnit;
      };
      input: {
        file: {
          width: {
            small: TokenWithUnit;
          };
        };
      };
      preview: {
        height: TokenWithUnit;
        width: TokenWithUnit;
      };
      thumbnail: {
        size: TokenWithUnit;
      };
    };
    button: {
      size: {
        large: TokenWithUnit;
        middle: TokenWithUnit;
        small: TokenWithUnit;
      };
    };
    dropdown: {
      menu: {
        borderRadius: TokenWithUnit;
        minWidth: TokenWithUnit;
        positionAtClickMinWidth: TokenWithUnit;
      };
    };
    menu: {
      itemMarginBlock: number;
    };
    message: {
      top: number;
    };
    modal: {
      scrollable: {
        padding: {
          lg: TokenWithUnit;
          md: TokenWithUnit;
        };
      };
    };
  };
}

export const reactComponentsCustomThemeConfig: ReactComponentsCustomThemeConfig = {
  reactComponents: {
    attachment: {
      file: {
        width: { unit: 'px', value: 206 },
      },
      input: {
        file: {
          width: {
            small: { unit: 'px', value: 160 },
          },
        },
      },
      preview: {
        height: { unit: 'px', value: 294 },
        width: { unit: 'px', value: 420 },
      },
      thumbnail: {
        size: { unit: 'px', value: 48 },
      },
    },
    button: {
      size: {
        large: { unit: 'px', value: 40 },
        middle: { unit: 'px', value: 32 },
        small: { unit: 'px', value: 24 },
      },
    },
    dropdown: {
      menu: {
        borderRadius: { unit: 'px', value: 4 },
        minWidth: { unit: 'px', value: 88 },
        positionAtClickMinWidth: { unit: 'px', value: 215 },
      },
    },
    menu: {
      itemMarginBlock: 0,
    },
    message: {
      top: 40,
    },
    modal: {
      scrollable: {
        padding: {
          lg: { unit: 'px', value: 24 },
          md: { unit: 'px', value: 16 },
        },
      },
    },
  },
};
